var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_372","data-name":"Path 372","d":"M37.78,144.926l-8.444-7.7a.706.706,0,0,0-.77-.11.638.638,0,0,0-.418.638v4.926H.7a.677.677,0,0,0-.7.7v4.222a.677.677,0,0,0,.7.7H28.148v4.926a.663.663,0,0,0,.418.638.686.686,0,0,0,.77-.132l8.444-7.785a.719.719,0,0,0,.22-.528A.7.7,0,0,0,37.78,144.926Z","transform":"translate(0 -137.052)"}));
}

Arrow.defaultProps = {"id":"arrow","viewBox":"0 0 38 16.887"};

module.exports = Arrow;

Arrow.default = Arrow;
